// extracted by mini-css-extract-plugin
export var chevronIcon = "_7l-2";
export var teamName = "_7l-1";
export var teamSwitcherButton = "_7l-0";